module.exports = __webpack_public_path__ + "static/media/dollarSign.5ba97347.svg";